export const formatRangeValueFilter = (fromValue, toValue, field) => {
    const filter = [];
    if (fromValue) {
        filter.push({
            field: field,
            op: '>',
            value: fromValue
        });
    }
    if (toValue) {
        filter.push({
            field: field,
            op: '<',
            value: toValue
        });
    }
    return filter;
};